// ─── IMOBMEET Design Tokens ───────────────────────────────
// Importe em qualquer componente:
// import { C, font } from '../tokens';

// Valores EXATOS extraídos do build de produção (imobmeet-site.netlify.app).
export const C = {
  primary:      "#204493",   // superfícies escuras, footer, CTA banner
  accent:       "#0560FF",   // CTAs, links, pills, destaques
  accentHover:  "#044ACC",   // hover do botão accent
  accentLight:  "#EEF4FF",   // fundo de pills e badges
  accentBorder: "#B8D0FF",   // borda de pills e badges
  surface:      "#FFFFFF",   // fundo geral / cartões
  surface2:     "#F4F7FF",   // superfície alternada
  white:        "#FFFFFF",   // alias de surface (compat)
  text:         "#0A0F1E",   // texto principal
  muted:        "#5E6E8A",   // texto secundário
  bgAlt:        "#F4F7FF",   // seções alternadas
  bgDeep:       "#EEF2FF",   // variação mais profunda
  heroFrom:     "#F7F9FF",   // gradiente do hero (início)
  heroTo:       "#FFFFFF",   // gradiente do hero (fim)
  heroBlob1:    "#EEF2FF",   // blob decorativo do hero
  heroBlob2:    "#E8F0FF",   // blob decorativo do hero
  border:       "#E2E8F0",   // bordas gerais
  success:      "#10B981",   // verde
  warning:      "#F59E0B",   // amarelo/laranja
  danger:       "#EF4444",   // vermelho
};

export const font = "'Plus Jakarta Sans', system-ui, sans-serif";
export const mono = "'IBM Plex Mono', ui-monospace, monospace";

// ─── Contato ───────────────────────────────────────────────
// Número de WhatsApp comercial do IMOBMEET (apenas dígitos, formato internacional).
export const WHATSAPP_NUMBER = "5511995565777";
export const WHATSAPP_DISPLAY = "(11) 99556-5777";

// ─── Flags ────────────────────────────────────────────────
// Menu "Funcionalidades" (mega-menu + link no rodapé/mobile). Desligado até o
// usuário finalizar os ajustes. Para religar: mude para true (e reative as URLs
// no scripts/gen-sitemap.js — const INCLUDE_FEATURES). As páginas continuam
// acessíveis por URL direta mesmo com o menu desligado.
export const SHOW_FEATURES_MENU = true;

// ─── Helpers reutilizáveis ────────────────────────────────

export const sectionStyle = (bg = C.white) => ({
  background: bg,
  padding: "88px 28px",
});

export const containerStyle = {
  maxWidth: 1180,
  margin: "0 auto",
};

export const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 64,
  alignItems: "center",
};

export const grid3 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: 20,
};

// Mock screen container padrão
export const mockContainer = {
  background: "#102060",
  borderRadius: 12,
  padding: 16,
  fontFamily: font,
};
